export const MESSAGE_SOURCE = 'the-savings-group';
